module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Icon/ico_info-fdf4740937117df709dc874f3fef6928.svg";